import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Button } from 'antd';

const Notice = props => {
  const { notice } = props;
  return (
    <Modal
      title={notice.title}
      centered
      visible={props.visible}
      onCancel={props.onCancel}
      destroyOnClose={true}
      width={600}
      className="help-dialog"
      keyboard={false}
      maskClosable={false}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            props.onCancel();
            sessionStorage.setItem('isLoadSystemNotice', 'true');
          }}
          className="btn-ok"
        >
          我知道了
        </Button>,
      ]}
    >
      <div className="helpBox">
        <div className="helpContent">
          <div className="helpBody">
            <p dangerouslySetInnerHTML={{ __html: notice.content }}></p>
          </div>
        </div>
      </div>
    </Modal>
  );
};
Notice.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  notice: PropTypes.object,
};
export default Notice;
